import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-datetime/dist/vue-datetime.css'
import 'core-js/es6/promise'
import 'core-js/es7/promise'
import 'core-js/es6/number'
import 'core-js/es6/object'
import 'core-js/es6/string'
import 'core-js/es6/math'
import 'core-js/es6/array'
import 'core-js/es7/array'
import 'svg-innerhtml-polyfill'
import 'intersection-observer'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from './i18n'
import axios from 'axios'
import InlineSvg from 'vue-inline-svg';
import VueSweetalert2 from 'vue-sweetalert2';
import Vuelidate from 'vuelidate'
import { Datetime } from 'vue-datetime'
import { Settings, DateTime } from 'luxon'
import { ContentLoader } from 'vue-content-loader'
import VueWaypoint from 'vue-waypoint'
import {getAccountUsingGET} from '@/api';
import Cookies from 'js-cookie'

import "./registerServiceWorker";
import "./directives";
import "./filters";

window.swalError = require("@/assets/icons/swal-error.svg");
window.swalSuccess = require("@/assets/icons/swal-success.svg");
window.swalInfo = require("@/assets/icons/swal-info.svg");

import {
    setDomain
} from '@/api.js'
setDomain(process.env.VUE_APP_API_URL)

if(store.state.token) {
    getAccountUsingGET().then(response => {
        if(response.status === 200) {
            i18n.locale = response.data.langKey;
            Cookies.set('langKey',response.data.langKey, { expires: 365 });

            let passwordChangedOn = DateTime.fromISO(response.data.passwordChangedOn),
                now = DateTime.local();
            /*
            if(passwordChangedOn.plus({ days: 90 }) < now) {
                Vue.swal({
                    title: i18n.$t("Jelszó"),
                    text: i18n.$t("A jelenlegi jelszava lejárt. Az e-mail címére elküldtük a jelszó cseréhez szükséges hivatkozást."),
                    imageUrl: window.swalError,
                });
                store.commit('logout');
                return router.push({name: 'login'});
            }
            */
        }
    });
}

Vue.component('inline-svg', InlineSvg);

axios.interceptors.response.use(null, function (error) {
    if (typeof error.response !== "undefined" && error.response.status === 401) {
        if (store.state.isAuthenticated) {
            store.commit('logout');
            router.replace({
                name: 'login'
            });
        }
    } else if (typeof error.response !== "undefined" && error.response.status === 412 && typeof error.response.data.resetKey !== "undefined") {
        Vue.swal({
            title: i18n.$t("Jelszó"),
            text: i18n.$t("A jelenlegi jelszava lejárt. Kérjük adjon meg új jelszót"),
            imageUrl: window.swalError,
        });
        store.commit('logout');
        return router.replace({
            name: 'reset-password',
            query: {key: error.response.data.resetKey}
        });
    } else if(typeof error.response === "undefined") {
		error.response = {
			status: 500,
			errorMessage: null
		}
		error.response.errorMessage = i18n.$t('A weboldalon tervezett karbantartási munkálatokat folytatunk. Kérem látogasson vissza néhány perc múlva.');
	} else {
		error.response.errorMessage = (typeof error.response.data === "undefined" || typeof error.response.data.detail === "undefined")? i18n.$t('Ismeretlen hiba') : error.response.data.detail === null? i18n.$t('Ismeretlen szerver hiba') : i18n.$t(error.response.data.detail);
	}
	
	return Promise.reject(error.response);
});

const swalOptions = {
    showCancelButton: false,
    buttonsStyling: false,
    customClass: {
        confirmButton: 'button button--blue button--swal',
        cancelButton: 'button button--swal',
        title: 'text-biggest font-weight-bold'
    }
};
Vue.use(VueSweetalert2, swalOptions);
Vue.use(Vuelidate);
Vue.use(VueWaypoint);
Vue.component('datetime', Datetime);
Settings.defaultLocale = 'hu';
Vue.component('content-loader',ContentLoader);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");